/**
 * An executeCommand response, as far as reading a failure from it goes. Declared so the compiler checks the
 * path: read through a dotted string, an upstream rename degrades the message with nothing failing.
 */
export interface ToolErrorEnvelope {
  executeCommand?: {
    success?: boolean;
    error?: {
      message?: string;
      extensions?: { response?: { body?: { exc_value?: string } } };
    };
  };
}

/** `??` rather than a lodash default, so a null exc_value falls through to the message. */
export const extractToolError = (
  data: ToolErrorEnvelope | null | undefined,
  fallbackLabel: string,
): string | undefined => {
  const command = data?.executeCommand;
  if (command?.success) {
    return undefined;
  }
  return (
    command?.error?.extensions?.response?.body?.exc_value ??
    command?.error?.message ??
    `${fallbackLabel} failed`
  );
};
